/** G2 embed: inject rating_schema.json as JSON-LD (once per page load). */
const SCRIPT_ID = 'g2-official-rating-schema'
import { G2_RATING_SCHEMA_URL } from './g2PublicStats'

let loadPromise = null

export function ensureG2OfficialRatingSchema() {
  if (typeof document === 'undefined') return Promise.resolve()
  if (document.getElementById(SCRIPT_ID)) return Promise.resolve()
  if (!loadPromise) {
    loadPromise = fetch(G2_RATING_SCHEMA_URL)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!data || document.getElementById(SCRIPT_ID)) return
        const script = document.createElement('script')
        script.id = SCRIPT_ID
        script.type = 'application/ld+json'
        script.text = JSON.stringify(data)
        const firstScript = document.getElementsByTagName('script')[0]
        if (firstScript?.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript)
        } else {
          document.head.appendChild(script)
        }
      })
      .catch(() => {})
  }
  return loadPromise
}
